/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PaginationSettings } from '../models/paginationsettings';
import { OperatorStatsCsvType } from '../models/OperarorStatsCsvEnum';

@Injectable({
  providedIn: 'root'
})
export class CallListService {
 
  
  private callsSource = new ReplaySubject<any>(1);
  calls$ = this.callsSource.asObservable();


 private callPaginationSource = new ReplaySubject<any>(1);
  callPagination$ = this.callPaginationSource.asObservable();

status: string | null;


 apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  addCall(callInput = {
    dateAndTimeOfCall: new Date(),
    operatorExtension: 0,
    visitorsPhone: '',
    status: 0
  }) {
    return this.http.post(this.apiUrl + 'calllist', {
      ...callInput
    });
  }

  getAllCalls() {
    let params = new HttpParams();

    return this.http.get(this.apiUrl + 'calllist', { params, observe: 'response' })
      .pipe(map((res: any) => {
        if (res) {

          this.callsSource.next(res.body);
        }
      }))
      .toPromise();
  }


getAllCallsSearch(body: any) {
  return this.http.post<any>(
    this.apiUrl + 'calllist/SearchCalls',
    body,
    { observe: 'response' }
  ).pipe(
    map(res => {
      const pagHeader = res.headers.get('pagination');

      if (pagHeader) {
        this.callPaginationSource.next(JSON.parse(pagHeader));
      }

      this.callsSource.next(res.body ?? []);
      return res.body;
    })
  );
}


  getCallById(id: number) {
    return this.http.get(this.apiUrl + 'calllist/' + id);
  }

  setBirthdayCall(birthdayId: number, callId: number) {
    // baseUrl npr. 'https://localhost:7134/' (OBAVEZNO da se završi sa '/')
    const url = `${this.apiUrl}CallList/${birthdayId}/call`;
    return this.http.put(url, null, {
      params: { callId },           // => ?callId=1
      responseType: 'text'
    });
  }

getFilteredCallStats(params: any): Observable<any> {
console.log( "getFilteredCallStats(params: any)",   params)

return this.http.post<any>(`${this.apiUrl}CallList/stats`, params);
}


 getOperators(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}CallList/operators`);
  }

getFilteredCallStatsOperators(params: any): Observable<any> {
console.log( "getFilteredCallStats(params: any)",   params)

return this.http.post<any>(`${this.apiUrl}CallList/statsOperaters`, params);
}


  attachBirthdayToCall(callId: number, birthdayId: number) {
    return this.http.put(`${this.apiUrl}CallList/${callId}/attach-birthday/${birthdayId}`, null, { responseType: 'text' });
  }


 exportStatsOperatorsCSV(
  filters: any,
  type: OperatorStatsCsvType
) {
  return this.http.post(
    `${this.apiUrl}CallList/exportStatsOperatorsCSV?type=${type}`,
    filters,
    { responseType: 'blob' }
  );
}

exportListCSV(
   filters: any,
)

{
  return this.http.post(
    `${this.apiUrl}CallList/exportCSV`,
    filters,
    { responseType: 'blob' }
  );
}


}







